import React from "react";
import PropTypes from "prop-types";
import * as S from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCirclePlus,
} from "@fortawesome/free-solid-svg-icons";

export const ModuleFondosReserva = ({
  data,
  metadata,
  requestAdd,
  access,
}) => {
  return (
    <S.Wrapper>
      <S.Header>
        <span>Fondos Reserva</span>
        {requestAdd && (
          <S.DivButton onClick={requestAdd} disabled={!access?.Editar}>
            <FontAwesomeIcon icon={faCirclePlus} size="lg" />
          </S.DivButton>
        )}
      </S.Header>
      <S.Content>
        <table>
          <thead>
            <S.TrColumnTitles>
              {metadata.map((e) => (
                <th key={e.name}>{e.label}</th>
              ))}
            </S.TrColumnTitles>
          </thead>
          <tbody>
            {data.map((register) => (
              <tr key={register.valor}>
                {metadata.map((field) => (
                  <td key={field.name}>
                    {register[field.name]}
                  </td>
                ))}
              </tr>
            ))}
            {data.length === 0 && (
              <tr>
                <td>No hay registros</td>
              </tr>
            )}
          </tbody>
        </table>
      </S.Content>
    </S.Wrapper>
  );
};

ModuleFondosReserva.propTypes = {
  data: PropTypes.array,
  metadata: PropTypes.array,
  requestAdd: PropTypes.func,
  requestCancel: PropTypes.func,
  access: PropTypes.object,
};
